import React from "react";
import { Progress } from "antd";
import {
  CIRCLE_TEAL,
  CIRCLE_SIZE,
  CIRCLE_STROKE_W,
  CardWrapperStyled,
  CircleFormatTextStyled,
  CardTitleStyled,
  CardSubtitleStyled,
} from "./ProgressCircleCardV2.styles";

const ProgressCircleCardV2 = ({ score, title, subtitle }) => (
  <CardWrapperStyled>
    <Progress
      type="circle"
      percent={Math.round(score)}
      size={CIRCLE_SIZE}
      strokeColor={CIRCLE_TEAL}
      strokeWidth={CIRCLE_STROKE_W}
      format={(pct) => <CircleFormatTextStyled>{pct}%</CircleFormatTextStyled>}
    />
    <CardTitleStyled strong>{title}</CardTitleStyled>
    <CardSubtitleStyled type="secondary">{subtitle}</CardSubtitleStyled>
  </CardWrapperStyled>
);

export default ProgressCircleCardV2;
